import { Typography } from "@material-tailwind/react";
import React from "react";
import { Link } from "react-router-dom";

function NoPageFound() {
  return (
    <div className="flex flex-col items-center justify-center !pl-20 p-4">
      <Typography color="blue-gray" className="font-extrabold text-2xl">
        Oops! The Requested Page does not exist.
      </Typography>
      <Link
        to="/"
        className="bg-[#030835] my-3 text-white p-2.5 px-4 text-[14px] font-bold  rounded-md hover:no-underline hover:shadow-2xl duration-300"
      >
        Go to Homepage
      </Link>
      <div className="flex justify-center w-[38%] h-[38%]">
        <img
          src="/assets/images/error.svg"
          className="w-full h-full mix-blend-darken"
          alt="No page found"
        />
      </div>
    </div>
  );
}

export default NoPageFound;
